<template>
  <div></div>
</template>

<script>
export default {
  name: 'TracingEnterpriseRoute',
};
</script>

<style scoped>

</style>
